import { FooterContactProps } from '@/app/components/layouts/footer/contact';

export const FOOTER_CONTACT: FooterContactProps = {
  title: 'ช่องทางการติดต่อ',
  contact: [
    {
      href: 'https://www.tripetchgroup.com/',
      image:
        'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blta0ce0ab3e39a763f/61dd8fa825d68c388a00fc2c/logo-tripetchgroup.svg',
      alt: 'ติดต่อกลุ่มตรีเพชร',
      value: 'logo-tripetchgroup',
    },
    {
      href: 'tel:021180777',
      image:
        'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt33f0eff0eb661808/621dd2525662980e56b3b7c3/logo-isuzu-hotline.svg',
      alt: 'ISUZU HOTLINE สายด่วน',
      value: 'logo-isuzu-hotline',
    },
  ],
};

export const FOOTER_COPYRIGHT =
  'สงวนลิขสิทธิ์ © 2025 บริษัท ตรีเพชรอีซูซุเซลส์ จำกัด';
